import { render, staticRenderFns } from "./DataTeacher.vue?vue&type=template&id=7899ad50&"
import script from "./DataTeacher.vue?vue&type=script&lang=js&"
export * from "./DataTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports